import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=a68ffd92&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=a68ffd92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68ffd92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68ffd92')) {
      api.createRecord('a68ffd92', component.options)
    } else {
      api.reload('a68ffd92', component.options)
    }
    module.hot.accept("./breadcrumb.vue?vue&type=template&id=a68ffd92&scoped=true", function () {
      api.rerender('a68ffd92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/breadcrumb/breadcrumb.vue"
export default component.exports